export default __webpack_public_path__ + "static/media/logo-card-768w.4f1e7fa5.avif";